import { render, staticRenderFns } from "./WaveletsTable.vue?vue&type=template&id=6985459e&"
import script from "./WaveletsTable.vue?vue&type=script&lang=js&"
export * from "./WaveletsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports